import NotFound from 'components/NotFound';
import AdminPractitionersLogs from 'components/admin/pages/Practitioners/Logs';
import AdminPractitionersPractices from 'components/admin/pages/Practitioners/Practices';
import PractitionersBasicInfo from 'components/admin/pages/Practitioners/PractitionersBasicInfo';
import PractitionersPatients from 'components/admin/pages/Practitioners/PractitionersPatients';
import Practitioners from 'components/admin/pages/Practitioners/PractitionersTable';
import PrescriptionManagement from 'components/admin/pages/Practitioners/PrescriptionManagement';
import AdminPractitionersSettings from 'components/admin/pages/Practitioners/Settings';
import NewPractitionerContainer from 'components/admin/pages/Practitioners/new_practitioner/indexContainer';
import PractitionerProfile from 'components/admin/pages/Practitioners/profile';

const ADMIN_PRACTITIONERS = [
  {
    path: 'practitioners',
    element: <Practitioners />,
    children: [
      {
        path: ':id',
        element: <PractitionerProfile />,
        children: [
          {
            path: '',
            element: <PractitionersBasicInfo />
          },
          {
            path: 'patients',
            element: <PractitionersPatients />
          },
          {
            path: 'eprescribe',
            element: <PrescriptionManagement />
          },
          {
            path: 'practices',
            element: <AdminPractitionersPractices />
          },
          {
            path: 'settings',
            element: <AdminPractitionersSettings />
          },
          {
            path: 'logs',
            element: <AdminPractitionersLogs />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: 'new',
        element: <NewPractitionerContainer />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default ADMIN_PRACTITIONERS;
